import { render, staticRenderFns } from "./bulk-buy.vue?vue&type=template&id=8ac38d68&scoped=true&"
import script from "./bulk-buy.vue?vue&type=script&lang=js&"
export * from "./bulk-buy.vue?vue&type=script&lang=js&"
import style0 from "./bulk-buy.scss?vue&type=style&index=0&id=8ac38d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac38d68",
  null
  
)

export default component.exports